<template>
  <main>
    <v-toolbar flat class="main-header main-header__shadow mb-6 px-5 py-2">
      <v-toolbar-title class="main-header__title">
        <h1>
          <span>{{ $t("new_answer") }}</span>
        </h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-container>
      <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
        <p
          class="mb-0"
          v-for="globalErr in globalServerErrors"
          :key="globalErr"
        >
          {{ globalErr[0] }}
        </p>
      </v-alert>
      <formWrapper :validator="$v.form">
        <form @submit.prevent="handleSave" class="form-box">
          <v-row>
            <v-col cols="12" lg="2" class="ma-auto">
              <section class="transparent-field mt-5">
                <v-switch
                  v-model="form.available"
                  inset
                  false-value="0"
                  true-value="1"
                  :label="$t('available')"
                  color="success"
                  dense
                ></v-switch>
              </section>
            </v-col>
            <v-col cols="12" lg="2" class="ma-auto">
              <section class="transparent-field mt-5">
                <v-switch
                  v-model="form.correct"
                  inset
                  false-value="0"
                  true-value="1"
                  :label="$t('correct')"
                  color="success"
                  dense
                ></v-switch>
              </section>
            </v-col>

            <v-col class="align-self-center" cols="12" lg="5">
              <form-group name="text" attribute="fields.answer">
                <template slot-scope="{ attrs, listeners }">
                  <v-textarea
                    v-bind="attrs"
                    v-on="listeners"
                    no-resize
                    rows="2"
                    outlined
                    v-model.trim="form.text"
                    :label="$t('fields.answer')"
                    type="text"
                    dense
                  >
                  </v-textarea>
                </template>
              </form-group>
            </v-col>

            <v-col cols="12" lg="3">
              <v-btn
                block
                class="success text-capitalize"
                large
                type="submit"
                height="60"
                :disabled="$v.form.$invalid"
                :loading="loading"
                ><span>{{ $t("button.save") }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </form>
      </formWrapper>
    </v-container>
  </main>
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import cookie from "js-cookie";

import { StoreData, UpdateData } from "@/helpers/apiMethods";

export default {
  name: "AnswersCrud",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isUpdateCase: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    DateTimePicker: () => import("@/components/DateTimePicker"),
    FileUpload: () => import("@/components/fileUpload"),
  },
  data() {
    return {
      globalServerErrors: null,
      isEdited: false,
      loadingData: false,
      loading: false,
      locale: cookie.get("language") || "en",
      reset: false,
      maxSize: 1.024,
      form: {
        text: "",
        available: "1",
        correct: "",
      },
    };
  },

  methods: {
    onImageSelect({ file }) {
      this.form.image = file;
      this.reset = false;
    },
    editCreateBoolean() {
      if (this.isUpdateCase) {
        this.isEdited = true;
      } else {
        this.isEdited = false;
      }
    },
    handleShowData(item) {
      this.form = {
        ...item,
        available: item.available ? "1" : "0",
        correct: item.correct ? "1" : "0",
      };
    },

    update(formData) {
      this.loading = true;

      UpdateData({
        reqName: `admin-panel/chapters/${this.$route.params.id}/questions/${this.$route.params.slug}/answers`,
        data: formData,
        id: this.item.id,
      })
        .then(() => {
          this.isEdited = false;
          this.loading = false;
          this.$emit("on-answer-change");
          this.resetData();
        })
        .catch((err) => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildData() {
      const formData = new FormData();
      for (const key in this.form) {
        if (this.form[key] !== "") {
          formData.append(key, this.form[key]);
        }
      }

      formData.append("locale", this.locale);

      if (this.isEdited) {
        formData.append("_method", "put");
      }
      return formData;
    },
    handleSave() {
      if (!this.isEdited) {
        this.create(this.buildData());
      } else {
        this.update(this.buildData());
      }
    },
    resetData() {
      this.form = {
        text: "",
        available: "1",
        correct: "",
      };
      this.$v.form.$reset();
    },

    create(formData) {
      this.loading = true;

      StoreData({
        reqName: `admin-panel/chapters/${this.$route.params.id}/questions/${this.$route.params.slug}/answers`,
        data: formData,
      })
        .then(() => {
          this.loading = false;
          this.resetData();
          this.$emit("on-answer-change");
        })
        .catch((err) => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    back() {
      history.go(-1);
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  watch: {
    item: {
      handler(itemValue) {
        if (itemValue) {
          this.handleShowData(itemValue);
        }
      },
      immediate: true,
    },
    isUpdateCase: {
      handler(value) {
        if (value) {
          this.editCreateBoolean();
        }
      },
      immediate: true,
    },
  },
  validations: {
    form: {
      text: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(40000),
      },
    },
  },
};
</script>
